module.exports = __webpack_public_path__ + "img/3bd2121ffb49200d7114c96336ee439e.361f2d3a.png";